import { ReactElement, useCallback, useContext } from 'react';
import Image from 'next/image';
import { Button, Heading } from '@appsumo/dorado-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import AppsumoPlus from '~/public/appsumo-plus.png';

import { CartContext } from '~/contexts/cart';
import { useCart } from '~/lib/cart';
import { APPSUMO_PLUS_DEAL_ID } from '~/lib/util/constants';

export const VALUE_PROPS = [
  '10% off every tool you buy',
  'Exclusive access to The Sauce',
  'Access to our full Masterclass library',
  'FREE Access to AppSumo Originals',
  'Get 72 extra hours to decide if tools are right for you',
  'Member-only deals',
  'Average saving of $75 on member-only deals',
  'Enjoy extra time to buy or upgrade on top deals you may have missed',
];

export default function PlusUpsellSidebar({
  hasPlusInCart = false,
}: {
  hasPlusInCart?: boolean;
}): ReactElement {
  const { user, plusUpsellVariant: variant } = useContext(CartContext);
  const { lineItemAdd } = useCart(undefined, true);
  const onPlusClick = useCallback(
    () => lineItemAdd(APPSUMO_PLUS_DEAL_ID),
    [lineItemAdd],
  );

  if (variant !== 'sidebar' || user?.has_plus || hasPlusInCart) {
    return <></>;
  }

  return (
    <div className="rounded-b border border-t-[5px] border-sundog border-t-ready-red p-4">
      <div className="text-center">
        <Image
          src={AppsumoPlus}
          alt="alt"
          className="mb-3 inline-block"
          height={20}
        />
        <p className="text-2xl font-medium">$99</p>
        <p className="text-sm">Annual membership</p>
      </div>
      <hr className="my-4" />
      <Heading.H2>All the perks!</Heading.H2>
      <ul className="mt-4 space-y-2">
        {VALUE_PROPS.map((valueProp) => (
          <li key={valueProp}>
            <div className="flex">
              <FontAwesomeIcon
                icon={faCheck}
                className="mr-2 mt-1 text-ready-red"
              />
              <p>{valueProp}</p>
            </div>
          </li>
        ))}
      </ul>
      <Button
        tertiary
        className="mt-4 mb-2 w-full text-center"
        onClick={onPlusClick}
      >
        Join Plus today
      </Button>
      <p className="text-sm italic text-grace">
        This membership is billed annually. You can cancel at any time and not
        be charged for the following year.
      </p>
    </div>
  );
}

export { PlusUpsellSidebar };
